module.exports = __webpack_public_path__ + "img/microphone.6a9ee40c.svg";